import { Injectable } from '@angular/core';
import { each } from 'lodash';
import { IStudentPath } from '../../typings/interfaces/studentPaths.interface';

@Injectable()
export class StudentPathsFilterService {
  constructor() {
    //
  }

  getFilteredStudentPaths(studentPathData: IStudentPath[]) {
    const studentPaths = [];
    each(studentPathData, (studentPath: IStudentPath) => {
      if (!this.isDeleted(studentPath) && !this.isClosed(studentPath)) {
        studentPaths.push(studentPath);
      }
    });
    return studentPaths;
  }

  isDeleted(studentPath: IStudentPath): boolean {
    return studentPath.status === 'DELETED';
  }

  isClosed(studentPath: IStudentPath): boolean {
    return studentPath.status === 'CLOSED';
  }
}
